import { baseApi } from 'components/constants/Constants';
import { SegmentTag } from 'types/global';
import { request } from '../api';
import { request as requestTS } from '../apiTS';
import { EventProduct, Product } from 'types/Products';
import { useAxiosWithAuth } from './useAxios';

export const getProductsByTypeAndCompany = (
  type: string | undefined,
  company: string,
  segment?: SegmentTag,
  isTrashed?: boolean,
  success?: (res: any) => void,
  handleError?: () => void,
  page?: number,
  size?: number,
  globalSearch?: string,
  filters?: { field: string; value: string | string[] }[],
  signal?: AbortSignal,
  productKeys?: string[]
) => {
  let defaultParams = `operator=OR&size=${size || 200}${
    page ? `&page=${page}` : ''
  }`;

  let endpoint = `${baseApi}/companies/${company}/products/types/${type}`;
  if (segment) {
    endpoint = `${baseApi}/companies/${company}/segments/${segment}/products/types/${type}`;
  }

  if (productKeys) {
    defaultParams += `&key=${productKeys.join(',')}`;
  }
  if (isTrashed) {
    defaultParams += '&trashed=true';
  }
  // endpoint += '?trashed=true';

  const options = {
    method: 'GET',
    url: `${endpoint}?${defaultParams}`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(signal ? { ...options, signal } : options, success, handleError);
};

export const getProductBookmark = (
  product: Product,
  success: (res: any) => void,
  handleError: () => void
) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/bookmark`,
    headers: { 'Content-Type': 'application/json' }
  };
  requestTS(options, success, handleError);
};

export const loadProductEventAssets = (
  eventKey: string,
  product: EventProduct,
  success: (res: any) => void,
  handleError?: () => void
) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/events/${eventKey}/companies/${product.company.key}/products/${product.product_event_key}/assets`,
    headers: { 'Content-Type': 'application/json' }
  };

  request(options, success, handleError);
};

export const deleteProductEventAsset = (
  eventKey: string,
  product: EventProduct,
  assetKey: string,
  success: (res: any) => void,
  handleError?: () => void
) => {
  const options = {
    method: 'DELETE',
    url: `${baseApi}/events/${eventKey}/companies/${product.company.key}/products/${product.product_event_key}/assets/${assetKey}`
  };

  request(options, success, handleError);
};

export const downloadProductEventAsset = (
  eventKey: string,
  product: EventProduct,
  assetKey: string,
  success: (res: any) => void,
  handleError?: () => void
) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/events/${eventKey}/companies/${product.company.key}/products/${product.product_event_key}/assets/${assetKey}/download`,
    responseType: 'blob'
  };

  request(options, success, handleError);
};

export const useUpdateProductName = (product: Product) =>
  useAxiosWithAuth(
    {
      url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/name`,
      method: 'POST'
    },
    { manual: true }
  );
